import { LogsBase } from "~/areas/configuration/components/Diagnostics/Logs/LogsBase";
export class SubscriptionLogsPage extends LogsBase {
    constructor(props: {}) {
        super("ProcessSubscriptions", "Subscription Logs", props);
    }
}
